<template>
  <div class="table-container">
    <el-table
      ref="table"
      :data="list"
      v-loading="pageLoading"
      style="width: 100%"
      border>
      <el-table-column
        :label="handleCommon('label.name')"
        min-width="150"
        header-align="center">
        <template
        slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        :label="handleCommon('label.email')"
        min-width="250"
        header-align="center">
        <template
          slot-scope="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>
      <el-table-column
        :label="handleCommon('label.social')"
        min-width="150"
        header-align="center">
        <template
          slot-scope="scope">
          {{ scope.row.social_id }}
        </template>
      </el-table-column>
      <el-table-column
        :label="handleCommon('label.status')"
        width="100"
        align="center">
        <template
          slot-scope="scope">
          {{ getStatus(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="handleCommon('label.createTime')"
        width="180"
        align="center">
        <template
          slot-scope="scope">
          {{ scope.row.created_time }}
        </template>
      </el-table-column>
      <el-table-column
        :label="handleCommon('setting.operating')"
        width="200"
        align="center">
        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip
              :content="handleCommon('setting.contactDetailBtn')"
              placement="top">
                <el-button
                  icon="el-icon-chat-line-square"
                  type="primary"
                  @click="handleDetail(scope.row)">
                </el-button>
            </el-tooltip>
            <el-tooltip
              :content="handleCommon('setting.editBtn')"
              placement="top">
                <el-button
                  icon="el-icon-edit-outline"
                  v-if="scope.row.status != 3"
                  type="success"
                  @click="handleEdit(scope.row)">
              </el-button>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import common from '@/utils/common'
import contactStatus from '@/utils/contactStatus'

export default {
  data() {
    return {
      moduleName: 'contact'
    }
  },
  computed: {
    list() {
      return this.handleStateGetter('dataList.list')
    },
    pageLoading() {
      return this.handleStateGetter('pageLoading')
    }
  },
  methods: {
    handleCommon(k) {
      return k.split('.').reduce((a, c) => a[c], common)
    },
    getStatus(code) {
      return contactStatus[code]
    },
    handleDetail(row) {
      this.$store.commit(`${this.moduleName}/SET_EDIT_OBJ`, row)
      this.handleStateSetter(`${this.moduleName}/UPDATE_STATE`, 'detailDialogVisible', true)
    },
    handleEdit(row) {
      this.$store.commit(`${this.moduleName}/SET_EDIT_OBJ`, row)
      this.handleStateSetter(`${this.moduleName}/UPDATE_STATE`, 'dataDialogVisible', true)
    },
    handleStateSetter(m, k, v) {
      this.$store.commit(m, { key: k, val: v })
    },
    handleStateGetter(k) {
      return eval(`this.$store.state.${this.moduleName}.${k}`)
    }
  }
}
</script>
